
import React from 'react';
import { deep_copy } from "../js-utils";
import faker from 'faker';

class OptionMenu {

  static type = "OptionMenu";

  constructor(name, menu = [], faker=null) {
    this.name = name;
    this.menu = menu;
    this.menu.forEach((item, index) => {
      item.index = index;
    });
    this.type = OptionMenu.type;
    this.faker = faker;
  }

  initState = state => {
    state[this.name.id] = {
      value: this.menu[0].id,
      disable: false,
      type: OptionMenu.type,
    };
  };

  loadFromState = (appState, componentState) => {
    if (appState) {
      if (appState[this.name.id]) {
        componentState[this.name.id] = {
          value: appState[this.name.id],
          disable: false,
          type: OptionMenu.type,
          highlight: false,
        }
      }
    }
  };

  /**
   * Returns the current {@link Name} instance.
   */
  getValue = state => {
    const raw = state[this.name.id];
    if (!raw || !raw.value) {
      return null;
    }
    return this.menu.find(item => item.id === raw.value);
  };

  /**
   * @param value is a {@link Name} instance.
   */
  valueToString = value => {
    return value.label;
  };

  getAppValue = appState => {
    return appState[this.name.id];
  }

  getAppLabel = appState => {
    const val = this.getAppValue(appState);
    return this.menu.find(item => item.id === val).label;
  }

  getSize = () => {
    return this.menu.length;
  };

  getMenu = index => {
    return this.menu[index];
  };

  random = faker => {
    return faker.random.arrayElement(this.menu).id;
  };

  setRandomValue(state) {
    const menu = faker.random.arrayElement(this.menu);
    this.setValue(state, menu.id);
  }

  getIndex = state => {
    let id = state[this.name.id].value;
    for(let i=0; i < this.menu.length; i++) {
      if (this.menu[i].id === id) {
        return i;
      }
    }
    return -1;
  };

  saveToState = state => {
    return {
      [this.name.id]: state[this.name.id].value,
    }
  };

  /**
   * If {@param value} is an integer, it indexes the menu
   * items. Else it sets the value string directly.
   * @param state {obj} The component state.
   */
  setValue = (state, value) => {
    if (Number.isInteger(value)) {
      let index = value;
      state[this.name.id].value = this.menu[index].id;
    } else if (typeof value === 'string') {
      // We assume 'value' is a menu id
      state[this.name.id].value = value;
    }
  };

  onChange = component => event => {
    let newState = deep_copy(component.state);
    let id = event.target.id;

    newState[id] = {
      value: event.target.value,
      disable: component.state[id].disable,
      type: component.state[id].type,
    };
    newState.dirty = true;
    newState.highlight_rects = [];

    if (this.onChangeCallback) {
      this.onChangeCallback(component, newState, this);
    }
    component.setState(newState);
  };

  onEnterLeave = (component, enter) => ev => {
    if (this.onMouseEnterCallback) {
      this.onMouseEnterCallback(component, enter);
    }
  };

  renderMenuDiv = (
    component, inputStyle, elem_prefix, elem_postfix, div_override = {}) => {
    const div_style = {
      ...div_override,
    };
    return (
      <div style={div_style}>
        <div>
          { elem_prefix }
        </div>
        <div>
          { this.renderMenu(component, inputStyle) }
        </div>
        { elem_postfix }
      </div>
    );
  };

  renderMenu = (component, inputStyle = {}) => {
    let items = [];

    this.menu.forEach(item => {
      items.push( (
        <option key={item.id} value={item.id}>
          { item.label }
        </option>
      ));
    });
    const backStyle = {
      fontFamily: "Poppins",
      fontSize: "1.1rem",
      padding: "0.2rem",
    };
    if (this.getDisabled(component.state)) {
      backStyle.backgroundColor = "#CCC";
    } else {
      backStyle.backgroundColor = "#FFF";
    }
    const menuStyle = {
      ...backStyle,
      ...inputStyle,
    };
    return (
      <select
        id={this.name.id}
        onChange={this.onChange(component)}
        disabled={component.state[this.name.id].disable}
        onMouseEnter={this.onEnterLeave(component, true)}
        onMouseLeave={this.onEnterLeave(component, false)}
        style={menuStyle}
        value={component.state[this.name.id].value}>
        { items }
      </select>
    )
  };

  setDisabled = (state, disabled) => {
    state[this.name.id].disable = disabled;
  };

  getDisabled = state => {
    return state[this.name.id].disable;
  };

  setHighlight = (state, highlight) => {
    state[this.name.id].highlight = highlight;
  }

  getHighlight = state => {
    return state[this.name.id].highlight;
  };

  render = (component, extraLabel = () => null) => {
    return (
      <div className="columns">
        <div className="column">
          { this.name.label }: { this.renderMenu(component) } { extraLabel() }
        </div>
      </div>
    );
  };
}

export { OptionMenu };
